// extracted by mini-css-extract-plugin
export default {"borderContainer":"AuthenticationContainer_borderContainer__EO8-c"};